import { z } from "zod";

export enum SettingKey {
  PRIMARY_COLOR = "PRIMARY_COLOR",
  SECONDARY_COLOR = "SECONDARY_COLOR",
  LOGO_URL = "LOGO_URL",
  CURRENCY_FORMAT = "CURRENCY_FORMAT",
  INVOICE_SETTING = "INVOICE_SETTING",
  BUSINESS_NAME = "BUSINESS_NAME",
  BUSINESS_ADDRESS = "BUSINESS_ADDRESS",
  BUSINESS_ADDRESS_2 = "BUSINESS_ADDRESS_2",
  BUSINESS_CITY = "BUSINESS_CITY",
  BUSINESS_STATE = "BUSINESS_STATE",
  BUSINESS_ZIP = "BUSINESS_ZIP",
  BUSINESS_EMAIL = "BUSINESS_EMAIL",
  HIDE_ADDRESS = "HIDE_ADDRESS",
  DELUXE_INVOICE_DEFAULT_CC = "DELUXE_INVOICE_DEFAULT_CC",
  DELUXE_HAS_CUSTOMER_SURCHARGE = "DELUXE_HAS_CUSTOMER_SURCHARGE",
  DELUXE_BUSINESS_SEASONAL_MONTHS = "DELUXE_BUSINESS_SEASONAL_MONTHS",
  DELUXE_ESTIMATED_AVERAGE_MONTHLY_VOLUME = "DELUXE_ESTIMATED_AVERAGE_MONTHLY_VOLUME",
  DELUXE_ESTIMATED_HIGHEST_TRANSACTION_AMOUNT = "DELUXE_ESTIMATED_HIGHEST_TRANSACTION_AMOUNT",
  DELUXE_IS_BUSINESS_SEASONAL = "DELUXE_IS_BUSINESS_SEASONAL",
  DELUXE_IS_PERSONAL_GUARANTOR = "DELUXE_IS_PERSONAL_GUARANTOR",
  DELUXE_PARTNER_ID = "DELUXE_PARTNER_ID",
}

export enum SettingValueType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  JSON = "JSON",
  LIST = "LIST",
  DICT = "DICT",
}

export enum SettingCategory {
  GENERAL = "GENERAL",
  BRANDING = "BRANDING",
  INVOICE = "INVOICE",
  SECURITY = "SECURITY",
  DISPLAY = "DISPLAY",
  INTEGRATIONS = "INTEGRATIONS",
}

export const ClientSettingsCategorySchema = z.enum([
  "general",
  "branding",
  "invoice",
  "security",
  "display",
  "integrations",
]);

export type ClientSettingsCategory = z.infer<
  typeof ClientSettingsCategorySchema
>;

export const InvoiceSettingsValueSchema = z.object({
  business_name: z.string().optional(),
  business_address: z.string().optional(),
  business_city: z.string().optional(),
  business_state: z.string().optional(),
  business_zip: z.string().optional(),
  business_email: z.string().optional(),
  payment_term: z.string().optional(),
  logo_url: z.string().optional(),
  primary_color: z.string().optional(),
  secondary_color: z.string().optional(),
});

export type InvoiceSettingsValue = z.infer<typeof InvoiceSettingsValueSchema>;

export const ClientSettingSchema = z.object({
  user_id: z.string(),
  setting_id: z.string(),
  key: z.string(),
  category: z.string(),
  value: z.any(),
  value_type: z.string(),
  description: z.string().optional(),
  modified_by: z.string().nullable(),
  active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ClientSetting = z.infer<typeof ClientSettingSchema>;

export const ClientSettingsResponseSchema = z.array(ClientSettingSchema);

export type ClientSettingsResponse = z.infer<
  typeof ClientSettingsResponseSchema
>;
